import { createContext, useContext } from "react"

const PlanningContext = createContext(null)

export const usePlanning = () => useContext(PlanningContext)

export default PlanningContext
